import React, { Component, Fragment } from 'react';
import {
    View,
    ScrollView,
    FlatList,
    ActivityIndicator,
    TouchableWithoutFeedback
} from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Moment from 'moment';
import { MaskService } from 'react-native-masked-text';

import { Creators as toastActions } from '../../store/ducks/toast';
import { Creators as pedidosActions } from '../../store/ducks/pedidos';
import { Creators as pedidoSelecionadoActions } from '../../store/ducks/pedido-selecionado';

import HeaderBar from '../../react-component/headerBar';
import ListIcon from '../../react-component/listIcon';
import Text from '../../react-component/textComponent';
import Modal from '../../react-component/modal';
import ProductImage from '../../react-component/productImage';

import { formatToReal, formatToMilhar } from '../../config/Format';

import EmptyState from './emptyState';
import Colors from '../../config/Colors';

import { urlCdn } from '../../services/Api';

import {
    getStatusList,
    changeStatusPedido,
    getPedidoDetalhe,
    buscarPorCodigoBarras,
    adicionarProdutoPedido,
    sendPedidoFila,
    imprimirPedido,
    saveVoucher,
    buscarComprovante
} from './api';

import { PEDIDO_STATUS } from '../../constants/status-pedido';
import { TIPO_ENTREGA_RETIRADA } from '../../constants/configuracao-horarios';

import { filterStatusEntrega, filterStatusRetirada } from './utils';

import ItemPedido from './itemPedido';

import styles, { StyledInput } from './styles';
import AvisoSincronizacao from '../avisoSincronizacao';

import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import HistoricoStatus from './historicoStatus';
import PedidoUsuario from './pedidoUsuario';
import { Tooltip } from '@mui/material';

import { CreditCard, ExpandLess, ExpandMore, LocalShipping, PaymentsOutlined, Person, Receipt, Schedule, Sms, Store } from '@mui/icons-material'

const barCode = require('../../assets/img/bar-code.png');

const dhFormat = 'YYYY-MM-DD HH:mm';

const unidadeMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 3,
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.'
});

class PedidoDetalhe extends Component {
    state = {
        idPedido: '',
        dsUsuario: '',
        list: [],
        idStatusPedido: 0,
        statusList: [],
        status: '',
        loading: true,
        showListSeparados: false,
        isOpenModal: false,
        codigoBarras: '',
        prodAdd: {},
        qtdProduto: Number(1).toFixed(3).replace('.', ','),
        isSearching: false,
        isSaving: false,
        isDisabledBtn: false,
        formaPagamento: {},
        msgModal: '',
        vlMultiplicadorVenda: 0,
        isSincronizarLoading: false,
        isSincronizarDisabled: false,
        statusHistorico: [],
        isOpenModalHistorico: false,
        isLoadingComprovante: false,
        comprovantePedido: null,
        isOpenModalComprovante: false,
        hasComprovante: false,
        dsTimeZone: null,
        pedidosUsuarios: [],
        hidePedidosUsuario: false
    };

    idStatusListRef = React.createRef();

    async componentDidMount() {
        const { idStatusList, pedidoSelecionado } = this.props,
            request = await getStatusList(idStatusList),
            { data = [] } = request.data,
            { idPedido } = pedidoSelecionado,
            loading = Boolean(idPedido);

        this.idStatusListRef.current = data;

        if (idPedido) {
            this.loadPedido(idPedido);
        }

        this.setState({ statusList: data, loading });
    }

    componentDidUpdate(prevState) {
        const { pedidoSelecionado } = this.props,
            { idPedido } = pedidoSelecionado;

        if (idPedido !== prevState.idPedido) {
            this.setState({
                ...this.state,
                loading: Boolean(idPedido),
                showListSeparados: false,
                isSincronizarDisabled: false,
                hidePedidosUsuario: false
            });

            this.loadPedido(idPedido);
        }
    }

    carregarComprovante = async () => {
        this.setState({ isLoadingComprovante: true });

        buscarComprovante(this.state.idPedido)
            .then((data) => {
                const { status = null } = data;

                if (status === 200) {
                    const file = new Blob([data.data], { type: 'image/jpeg' });

                    const fileReaderInstance = new FileReader();

                    fileReaderInstance.readAsDataURL(file);
                    fileReaderInstance.onload = () => {
                        const base64data = fileReaderInstance.result;

                        this.setState({
                            isLoadingComprovante: false,
                            comprovantePedido: base64data,
                            hasComprovante: true
                        });
                    };
                } else {
                    this.setState({
                        isLoadingComprovante: false,
                        hasComprovante: false
                    });
                }
            })
            .catch(() => {
                this.setState({
                    isLoadingComprovante: false,
                    hasComprovante: false
                });
            });
    };

    async loadPedido(idPedido) {
        if (idPedido) {
            const { isHistorico } = this.props;

            const list = await getPedidoDetalhe(idPedido);
            const {
                    usuario,
                    idStatusPedido,
                    statusHistorico = [],
                    pedidosUsuarios = [],
                    formaPagamento,
                    idTipoEntregaRetirada
                } = list || {},
                { dsUsuario } = usuario || {};

            let newStatusList = this.idStatusListRef.current;

            if (isHistorico) {
                if (idTipoEntregaRetirada === TIPO_ENTREGA_RETIRADA.ENTREGA) {
                    newStatusList = filterStatusEntrega({
                        currentStatus: idStatusPedido,
                        statusList: this.idStatusListRef.current
                    });
                }

                if (idTipoEntregaRetirada === TIPO_ENTREGA_RETIRADA.RETIRADA) {
                    newStatusList = filterStatusRetirada({
                        currentStatus: idStatusPedido,
                        statusList: this.idStatusListRef.current
                    });
                }
            }

            this.setState({
                ...this.state,
                idPedido,
                dsUsuario,
                idStatusPedido,
                list,
                loading: false,
                statusHistorico,
                formaPagamento,
                pedidosUsuarios,
                filteredStatusList: newStatusList
            });

            this.carregarComprovante();
        }
    }

    statusChanged = async (idStatusPedido, statusPedido = null) => {
        this.setState({ loading: true });

        let newIdStatusPedido = idStatusPedido;

        if (statusPedido !== null) {
            newIdStatusPedido = this.state.statusList[0].idStatusPedido;
        }

        const { idPedido } = this.state,
            response = await changeStatusPedido(idPedido, newIdStatusPedido),
            { errors = null, message } = response;

        this.props.addToast({
            text: errors || message,
            more: 'OK',
            theme: errors ? 'error' : 'success'
        });

        this.setState({ loading: false });

        if (message) {
            const { searchPedidos, deselectPedido } = this.props,
                idsBusca = `${PEDIDO_STATUS.AGUARDANDO},${PEDIDO_STATUS.RECEBIDO}`;

            const location = window.location.pathname;

            if (location === '/') {
                await searchPedidos({ idStatusPedido: idsBusca });
            }
            deselectPedido();
        }
    };

    onPressHeaderList = () => {
        this.setState({ showListSeparados: !this.state.showListSeparados });
    };

    ListHeaderComponent = (itens) => {
        const Icon = this.state.showListSeparados
            ? ExpandLess
            : ExpandMore

        return (
            <TouchableWithoutFeedback onPress={this.onPressHeaderList}>
                <View style={styles.headerList}>
                    <Text style={styles.headerListInfo}>
                        Itens separados: {itens.length}
                    </Text>
                    <View style={styles.headerListIcon}>
                        <Icon />
                    </View>
                </View>
            </TouchableWithoutFeedback>
        );
    };

    renderItem = (item) => {
        const { idPedido, idStatusPedido, list } = this.state,
            { showItemActions } = this.props;

        return (
            <ItemPedido
                item={item}
                idPedido={idPedido}
                idStatusPedido={idStatusPedido}
                updateItemList={this.updateItemList}
                showItemActions={showItemActions}
                formaPagamento={list.formaPagamento}
            />
        );
    };

    dhLabel = (dhEntregaRetirada, dhEntregaRetiradaFinal) => {
        let label = '';

        if (dhEntregaRetiradaFinal) {
            label =
                Moment(dhEntregaRetirada, dhFormat).format(
                    'DD/MM/YYYY [das] HH:mm '
                ) +
                Moment(dhEntregaRetiradaFinal, dhFormat).format('[às] HH:mm');
        } else {
            label = Moment(dhEntregaRetirada, dhFormat).format(
                'DD/MM/YYYY [às] HH:mm '
            );
        }

        return label;
    };

    onLoadImage = async (e) => {
        this.setState({ isLoadingComprovante: true });

        if (
            e.currentTarget &&
            e.currentTarget.files.length > 0 &&
            this.validateImage(e.currentTarget.files[0])
        ) {
            const image = e.currentTarget.files[0];

            const formData = new FormData();

            formData.append('image', image);
            formData.append('idPedido', this.state.idPedido);

            try {
                await saveVoucher(formData);

                this.setState({ isLoadingComprovante: false });

                this.carregarComprovante();
            } catch (error) {
                this.setState({ isLoadingComprovante: false });
            }
        } else {
            this.setState({ isLoadingComprovante: false });
        }
    };

    validateImage = (file) => {
        var type = file.type.split('/').pop().toLowerCase();

        if (
            type !== 'jpeg' &&
            type !== 'jpg' &&
            type !== 'png' &&
            type !== 'gif'
        ) {
            this.toastCaller(
                'O tipo da imagem deve ser jpeg, jpg, png ou gif.',
                'error',
                4500
            );
            return false;
        }

        if (file.size > 20000000) {
            this.toastCaller(
                'O tamanho da imagem deve possuir no máximo 20 MB.',
                'error',
                4500
            );
            return false;
        }

        return true;
    };

    toastCaller = (message, theme, autoHideTime) => {
        this.props.addToast({
            text: message,
            theme: theme,
            autoHideTime: autoHideTime
        });
    };

    statusPedido = () => {
        const { statusHistorico } = this.state;

        if (statusHistorico.length > 1) {
            return statusHistorico[statusHistorico.length - 1].dsStatusPedido;
        }

        return statusHistorico[0].dsStatusPedido;
    };

    hoursDatePedido = () => {
        const { statusHistorico } = this.state,
            { user = {} } = this.props,
            { configLoja = {} } = user,
            { dsTimeZone } = configLoja;

        if (statusHistorico.length > 1) {
            return ` às ${this.toHours(
                statusHistorico[statusHistorico.length - 1].dhInclusao,
                dsTimeZone
            )}, ${this.toDateAndMonth(
                statusHistorico[statusHistorico.length - 1].dhInclusao
            )}`;
        }

        return ` às ${this.toHours(
            statusHistorico[0].dhInclusao,
            dsTimeZone
        )}, ${this.toDateAndMonth(statusHistorico[0].dhInclusao)}`;
    };

    toDateAndMonth = (dhInclusao) => {
        return `${Moment(dhInclusao).format('DD/MM')}`;
    };

    toHours = (value, dsTimeZone = null) => {
        if (dsTimeZone) {
            const date = Moment.tz(value, dsTimeZone);

            return Moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm');
        }

        return Moment(value, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm');
    };

    openModalComprovante = () => {
        this.setState({ isOpenModalComprovante: true });
    };

    closeModalComprovante = () => {
        this.setState({ isOpenModalComprovante: false });
    };

    setHidePedidosUsuario = () => {
        const { hidePedidosUsuario } = this.state;

        this.setState({
            hidePedidosUsuario: !hidePedidosUsuario
        });
    };

    renderContent = () => {
        const { list, dsUsuario, showListSeparados } = this.state,
            {
                endereco = {},
                dhEntregaRetirada,
                dhEntregaRetiradaFinal,
                usuario = {},
                formaPagamento
            } = list,
            dsObservacao = list.dsObservacao ? list.dsObservacao : false,
            {
                dsLogradouro,
                nrEndereco,
                dsComplemento,
                dsBairro,
                dsCidade = '',
                sgEstado = '',
                nrCep = ''
            } = endereco;
        const isEntrega =
            list.idTipoEntregaRetirada === TIPO_ENTREGA_RETIRADA.ENTREGA;

        const { voucher = {} } = list;
        const { dsCrm = 'Voucher', vlVoucherAplicado = 0.0 } = voucher;

        const enderecoObj = {
            ...(dsLogradouro && { dsLogradouro }),
            ...(nrEndereco && { nrEndereco }),
            ...(dsComplemento && { dsComplemento }),
            ...(dsBairro && { dsBairro }),
            ...(dsCidade && { dsCidade }),
            ...(sgEstado && { sgEstado }),
            ...(nrCep && { nrCep: `CEP: ${nrCep}` })
        };

        let dsEndereco = '';

        for (const key in enderecoObj) {
            if (key === 'dsLogradouro') {
                dsEndereco += endereco[key];
                continue;
            }
            dsEndereco += ', ' + enderecoObj[key];
        }

        const dsHorarioEntregaRetirada = {
            icon: Schedule,
            label: this.dhLabel(dhEntregaRetirada, dhEntregaRetiradaFinal)
        };
        const tpEntrega = {
            label: isEntrega ? 'Entrega' : 'Retirada',
            description: dsEndereco,
            icon: isEntrega ? LocalShipping : Store
        };
        const {
            dsFormaPagamento: labelFormaPagamento = '',
            dsCartaoBandeira = '',
            dsCartaoMascara = ''
        } = formaPagamento;
        const isPagamentoDinheiro = /dinheiro/gi.test(labelFormaPagamento);
        const dsFormaPagamento = {
            label: labelFormaPagamento,
            icon: isPagamentoDinheiro ? PaymentsOutlined : CreditCard
        };
        if (!isPagamentoDinheiro && dsCartaoBandeira && dsCartaoMascara) {
            dsFormaPagamento.label += ` ${
                dsCartaoBandeira.charAt(0).toUpperCase() +
                dsCartaoBandeira.slice(1)
            } (**** ${dsCartaoMascara.slice(dsCartaoMascara.length - 4)})`;
        }
        const itensSeparados = [],
            itens = [],
            orcamento = {
                label: `Orçamento: ${
                    list.idPedidoLoja > 0
                        ? list.idPedidoLoja
                        : 'Erro ao sincronizar'
                }`,
                icon: Receipt
            },
            nrTelefone =
                (usuario.nrTelefone &&
                    'Telefone: ' +
                        MaskService.toMask('cel-phone', usuario.nrTelefone, {
                            maskType: 'BRL',
                            withDDD: true,
                            dddMask: '(99) '
                        })) ||
                '',
            dsCpfCnpj =
                (usuario.dsCpfCnpj &&
                    'Cpf: ' + MaskService.toMask('cpf', usuario.dsCpfCnpj)) ||
                '',
            dsEmail = (usuario.dsEmail && `E-mail: ${usuario.dsEmail}`) || '',
            usuarioLabel = `${dsUsuario}, ${dsCpfCnpj}, ${nrTelefone}, ${dsEmail}`;

        list.itens.filter((item) =>
            item.fgSeparado ? itensSeparados.push(item) : itens.push(item)
        );

        const hasItens = itens.length > 0,
            hasSeparados = itensSeparados.length > 0;

        return (
            <Fragment>
                <View style={styles.container}>
                    <AvisoSincronizacao />

                    <div
                        style={{
                            alignItems: 'center',
                            backgroundColor: Colors.grey_light,
                            justifyContent: 'center',
                            paddingBottom: 15,
                            paddingTop: 15
                        }}
                    >
                        <div style={{ paddingLeft: 16 }}>
                            {this.state.statusHistorico.length > 0 && (
                                <p
                                    style={{
                                        fontFamily: 'NunitoSans-Regular',
                                        fontSize: '1.6rem'
                                    }}
                                >
                                    <span
                                        style={{
                                            fontFamily: 'NunitoSans-Bold',
                                            fontSize: '1.6rem'
                                        }}
                                    >
                                        {this.statusPedido()}
                                    </span>

                                    {this.hoursDatePedido()}
                                </p>
                            )}

                            {this.state.idStatusPedido > 2 &&
                                (this.state.hasComprovante ? (
                                    <p
                                        style={{
                                            color: Colors.secondary,
                                            fontFamily: 'NunitoSans-Bold',
                                            fontSize: '1.6rem',
                                            cursor: 'pointer',
                                            marginTop: 15,
                                            width: 180
                                        }}
                                        onClick={this.openModalComprovante}
                                    >
                                        Visualizar comprovante
                                    </p>
                                ) : (
                                    <label
                                        style={{
                                            padding: '10px 10px',
                                            width: 180,
                                            backgroundColor: Colors.grey_light,
                                            color: Colors.secondary,
                                            border: `solid 1px ${Colors.secondary}`,
                                            borderRadius: 6,
                                            textAlign: 'center',
                                            display: 'block',
                                            cursor: 'pointer',
                                            marginTop: 15,
                                            marginBottom: 15
                                        }}
                                    >
                                        {this.state.isLoadingComprovante ? (
                                            <ActivityIndicator
                                                color={Colors.secondary}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    fontFamily:
                                                        'NunitoSans-Regular',
                                                    fontSize: 14
                                                }}
                                            >
                                                Anexar comprovante
                                            </span>
                                        )}

                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            onChange={this.onLoadImage}
                                            accept="image/x-png,image/jpeg,image/gif,image/jpg"
                                            disabled={
                                                this.state.isLoadingComprovante
                                            }
                                        />
                                    </label>
                                ))}

                            {this.state.statusHistorico.length > 0 && (
                                <p
                                    style={{
                                        color: Colors.secondary,
                                        fontFamily: 'NunitoSans-Bold',
                                        fontSize: '1.6rem',
                                        cursor: 'pointer',
                                        width: 180,
                                        marginTop: 15
                                    }}
                                    onClick={this.openStatusHistorico}
                                >
                                    Ver histórico
                                </p>
                            )}
                        </div>
                    </div>

                    {this.state.idStatusPedido === PEDIDO_STATUS.AGUARDANDO ||
                        (this.state.idStatusPedido ===
                            PEDIDO_STATUS.RECEBIDO && (
                            <PedidoUsuario
                                pedidosUsuario={this.state.pedidosUsuarios}
                                usuario={this.state.dsUsuario}
                                toHours={this.toHours}
                                handler={this.loadPedido.bind(this)}
                                hideItems={this.state.hidePedidosUsuario}
                                handlerHidePedidos={this.setHidePedidosUsuario}
                                selectPedido={this.props.selectPedido}
                            />
                        ))}

                    <ScrollView>
                        <Fragment>
                            <ListIcon
                                Icon={Person}
                                color={Colors.greyDark}
                                label={usuarioLabel}
                                style={styles.orderDetailHeader}
                            />

                            {list.idPedidoLoja && (
                                <ListIcon
                                    Icon={orcamento.icon}
                                    color={Colors.greyDark}
                                    label={orcamento.label}
                                    style={styles.orderDetailHeader}
                                />
                            )}

                            <ListIcon
                                Icon={tpEntrega.icon}
                                uncommonIcon={isEntrega}
                                color={Colors.greyDark}
                                title={`${tpEntrega.label}: ${tpEntrega.description}`}
                                style={[styles.orderDetailHeader]}
                            />

                            <ListIcon
                                Icon={dsHorarioEntregaRetirada.icon}
                                color={Colors.greyDark}
                                label={dsHorarioEntregaRetirada.label}
                                style={styles.orderDetailHeader}
                            />

                            <ListIcon
                                Icon={dsFormaPagamento.icon}
                                label={dsFormaPagamento.label}
                                color={Colors.greyDark}
                                style={styles.orderDetailHeader}
                            />

                            {!!voucher && voucher.vlVoucherAplicado && (
                                <ListIcon
                                    Icon={dsFormaPagamento.icon}
                                    label={`${dsCrm} - R$ (${formatToReal(
                                        voucher.vlVoucherAplicado
                                    )})`}
                                    color={Colors.greyDark}
                                    style={styles.orderDetailHeader}
                                />
                            )}

                            {dsObservacao && (
                                <ListIcon
                                    Icon={Sms}
                                    title={'Observação:'}
                                    boldTitle={true}
                                    color={Colors.greyDark}
                                    label={dsObservacao}
                                    style={[
                                        styles.orderDetailHeader,
                                        { marginLeft: 0 }
                                    ]}
                                />
                            )}
                        </Fragment>

                        {hasItens && (
                            <FlatList
                                data={itens}
                                renderItem={({ item }) => this.renderItem(item)}
                                keyExtractor={(item) =>
                                    `${item.idPedidoProduto}`
                                }
                            />
                        )}

                        {hasSeparados && (
                            <Fragment>
                                {this.ListHeaderComponent(itensSeparados)}

                                {showListSeparados && (
                                    <FlatList
                                        data={itensSeparados}
                                        renderItem={({ item }) =>
                                            this.renderItem(item)
                                        }
                                        keyExtractor={(item) =>
                                            `${item.idPedidoProduto}`
                                        }
                                    />
                                )}
                            </Fragment>
                        )}
                    </ScrollView>
                    {this.state.isOpenModal && this.modalAddProduto()}

                    {this.state.isOpenModalHistorico &&
                        this.modalStatusHistorico()}

                    {this.state.isOpenModalComprovante &&
                        this.modalComprovante()}

                    {this.renderFooter()}
                </View>
            </Fragment>
        );
    };

    renderFooter = () => {
        const { list } = this.state,
            vlAdicionais = list.vlFrete + list.vlTaxaComodidade,
            vlFrete = formatToReal(list.vlFrete),
            vlTaxaComodidade = formatToReal(list.vlTaxaComodidade),
            { itens, idStatusPedido } = list;

        const { voucher = {} } = list;

        const { vlVoucherAplicado = '' } = voucher;

        let vlSeparadoAux = 0;

        if (idStatusPedido > 2) {
            if (idStatusPedido === 6) {
                vlSeparadoAux += list.vlTotal;
            }
            vlSeparadoAux += list.vlTotalSeparado;
        } else {
            itens.forEach((item) => {
                vlSeparadoAux +=
                    item.fgSeparado === 1 ? item.vlTotalSeparado : 0;
            });
        }

        const vlTotalSeparado = Number(
            vlSeparadoAux + vlAdicionais
        ).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        return (
            <View style={styles.footer}>
                <View style={styles.footerItem}>
                    <Text style={styles.footerLabel}>Frete:</Text>
                    <View style={styles.footerPrice}>
                        <Text style={styles.footerPriceText}>R$ {vlFrete}</Text>
                    </View>
                </View>
                <View style={styles.footerItem}>
                    <Text style={styles.footerLabel}>Comodidade:</Text>
                    <View style={styles.footerPrice}>
                        <Text style={styles.footerPriceText}>
                            R$ {vlTaxaComodidade}
                        </Text>
                    </View>
                </View>

                {!!list.voucher && list.voucher.vlVoucherAplicado && (
                    <View style={styles.footerItem}>
                        <Text style={styles.footerLabel}>
                            Subtotal
                            {` (R$ ${formatToReal(
                                vlSeparadoAux
                            )} - R$ ${formatToReal(vlVoucherAplicado)}):`}
                        </Text>
                        <View style={styles.footerPrice}>
                            <Text style={styles.footerPriceText}>
                                {`R$ ${formatToReal(vlSeparadoAux - vlVoucherAplicado)}`}
                            </Text>
                        </View>
                    </View>
                )}

                <View style={styles.footerItem}>
                    <Text style={styles.footerLabel} $bold>
                        Total:
                    </Text>
                    <View style={styles.footerPrice}>
                        <Text style={styles.footerPriceText} $bold>
                            {vlTotalSeparado}
                        </Text>
                    </View>
                </View>
            </View>
        );
    };

    removePedidoStore = () => {
        const { deselectPedido } = this.props;

        deselectPedido();
    };

    buscarPdfPedido = async (idPedido) => {
        const response = await imprimirPedido(idPedido),
            { data } = response;

        const file = new Blob([data], { type: 'application/pdf' }),
            printWindow = window.open(
                URL.createObjectURL(file),
                '',
                'width=1200,height=800'
            );

        printWindow.print();
    };

    renderList = () => {
        const { pedidoSelecionado } = this.props || {},
            { idPedido } = pedidoSelecionado || {},
            { list, filteredStatusList, formaPagamento } = this.state,
            { itens } = list,
            { idStatusPedido } = list || {},
            { idPedidoLoja, idTipoEntregaRetirada } = list,
            title = `#${idPedido}`;

        const listSeparado =
                list &&
                list.itens &&
                list.itens
                    .map((item) => {
                        return !!item.fgSeparado;
                    })
                    .includes(true),
            hasSeparados = !listSeparado;


        return (
            (idPedido && (
                <View style={styles.container}>
                    <HeaderBar
                        navigation={this.props.navigation}
                        hasBack={this.props.hasBack || false}
                        returnCallback={this.removePedidoStore}
                        hasChangeStatus={true}
                        statusList={filteredStatusList}
                        currentStatus={idStatusPedido}
                        onStatusChange={this.statusChanged}
                        style={styles.headerBar}
                        disableStatusButton={hasSeparados}
                        onPressSincronizar={this.onPressSincronizar}
                        isSincronizarLoading={this.state.isSincronizarLoading}
                        isSincronizarDisabled={
                            this.state.isSincronizarDisabled ||
                            idPedidoLoja > 0 ||
                            idStatusPedido === PEDIDO_STATUS.CANCELADO
                        }
                        openModalAddProduto={this.openModalAddProduto}
                        listItens={itens}
                        buscarPdfPedido={() => this.buscarPdfPedido(idPedido)}
                        idTipoEntregaRetirada={idTipoEntregaRetirada}
                    >
                        <View style={styles.pageHeader}>
                            <Text $bold style={styles.pageTitle}>
                                {title}
                            </Text>
                        </View>
                    </HeaderBar>

                    {list && list.itens ? (
                        this.renderContent()
                    ) : (
                        <View style={styles.loading}>
                            <ActivityIndicator size="large" />
                        </View>
                    )}
                </View>
            )) || <EmptyState />
        );
    };

    render() {
        const { loading } = this.state;

        return (
            <View style={styles.container}>
                {loading ? (
                    <ActivityIndicator style={styles.loading} size="large" />
                ) : (
                    this.renderList()
                )}
            </View>
        );
    }

    updateItemList = (item) => {
        const { list } = this.state;

        list.itens = list.itens.map((itemRec) =>
            itemRec.idPedidoProduto === item.idPedidoProduto ? item : itemRec
        );

        const itens = list.itens.filter((item) => !item.fgSeparado),
            hasItens = itens.length > 0;

        if (!hasItens) this.setState({ showListSeparados: true });

        this.setState({ list });
    };

    // Todo CSS foi criado no padrão style={{ ... }} devido a um erro interno que ocorre no React

    handleQuantidadeChange = (e) => {
        let { value } = e.target;

        if (value && value.length >= 11) return;
        if (!this.state.prodAdd.fgPesavel) {
            if (value.includes(',')) value = value.replace(',', '');

            if (this.isDecimal(value)) {
                value = parseInt(value || this.state.vlMultiplicadorVenda, 10);
            }
        }

        this.setState({ qtdProduto: value });
    };

    handleQuantidadeBlur = () => {
        let qtdProduto = this.state.qtdProduto;

        if (qtdProduto && String(qtdProduto).includes(',')) {
            qtdProduto = qtdProduto.replace(',', '.');
        }

        qtdProduto = formatToMilhar(qtdProduto);

        this.setState({ qtdProduto });
    };

    isDecimal = (num) => {
        if (isNaN(num)) return false;

        return parseInt(num, 10) !== parseFloat(num);
    };

    changeCodigoBarras = (e) => {
        if (!e.target.value) this.setState({ codigoBarras: '' });

        this.setState({ codigoBarras: e.target.value });
    };

    buscarPorCodigoBarras = async () => {
        this.setState({
            isSearching: true,
            qtdProduto: Number(1).toFixed(3).replace('.', ',')
        });

        const { codigoBarras } = this.state;

        if (!codigoBarras.length) {
            this.state.msgModal =
                'Por favor, informe o código de barras do produto.';

            this.setState({ isSearching: false });

            return;
        }

        const { data } = await buscarPorCodigoBarras(codigoBarras);

        if (!data.length) {
            this.setState({
                prodAdd: {},
                isSearching: false,
                msgModal: 'Produto não encontrado'
            });

            return;
        }

        const parsedProduct = { ...data[0] };

        if (
            parsedProduct.lsProdutoImagem &&
            parsedProduct.lsProdutoImagem.length
        ) {
            parsedProduct.lsProdutoImagem = JSON.parse(
                parsedProduct.lsProdutoImagem
            );
        }

        let qtdProduto = formatToMilhar(parsedProduct.vlMultiplicadorVenda);

        this.setState({
            prodAdd: parsedProduct,
            qtdProduto,
            vlMultiplicadorVenda: parsedProduct.vlMultiplicadorVenda,
            isSearching: false,
            msgModal: ''
        });
    };

    openModalAddProduto = () => {
        this.setState({ isOpenModal: true });
    };

    openStatusHistorico = () => {
        const { user = {} } = this.props,
            { configLoja = {} } = user,
            { dsTimeZone } = configLoja;

        this.setState({ isOpenModalHistorico: true, dsTimeZone });
    };

    inserirProdutoPedido = async () => {
        if (Object.keys(this.state.prodAdd).length) {
            this.setState({ isSaving: true });

            let qtdProduto = this.state.qtdProduto;

            if (String(qtdProduto).includes(',')) {
                qtdProduto = qtdProduto.replace(',', '.');
            }

            if (Number(qtdProduto) === 0) {
                this.props.addToast({
                    text: 'Não é possível adicionar produto com quantidade zerada.',
                    more: 'OK',
                    theme: 'error'
                });

                this.setState({ isSaving: false });

                return;
            }

            try {
                const response = await adicionarProdutoPedido({
                    idPedido: this.state.idPedido,
                    itens: [
                        {
                            nrEan: this.state.prodAdd.nrEan,
                            qtProduto: Number(qtdProduto)
                        }
                    ]
                });

                const { data } = response;

                this.setState({
                    ...this.state,
                    codigoBarras: '',
                    prodAdd: {},
                    qtdProduto: 1,
                    isSearching: false,
                    isSaving: false,
                    isDisabledBtn: false,
                    msgModal: data.message
                });

                this.loadPedido(this.state.idPedido);

                this.props.addToast({
                    text: 'Produto adicionado ao pedido com sucesso',
                    more: 'OK',
                    theme: 'success'
                });

                setTimeout(() => {
                    this.closeModal(true);

                    this.setState({ showListSeparados: true });
                }, 1500);
            } catch (err) {
                this.setState({ isSaving: false });

                this.props.addToast({
                    text: err[0].message,
                    more: 'OK',
                    theme: 'error'
                });
            }
        } else {
            this.props.addToast({
                text: 'Nenhum produto selecionado',
                more: 'OK',
                theme: 'error'
            });
        }
    };

    closeModal = (confirm = false) => {
        if (!this.state.isSaving) {
            if (Object.keys(this.state.prodAdd).length === 0 || confirm) {
                this.setState({
                    ...this.state,
                    isOpenModal: false,
                    codigoBarras: '',
                    prodAdd: {},
                    qtdProduto: Number(1).toFixed(3).replace('.', ','),
                    isSearching: false,
                    isSaving: false,
                    isDisabledBtn: false,
                    msgModal: ''
                });
            } else {
                const validate = window.confirm(
                    'Cancelar inclusão de produto?'
                );

                if (validate) {
                    this.closeModal(true);
                }
            }
        }
    };

    calcValTotalProd = (valUnitario) => {
        let qtdProduto = this.state.qtdProduto;

        if (String(qtdProduto).includes(',')) {
            qtdProduto = qtdProduto.replace(',', '.');
        }

        if (isNaN(qtdProduto)) {
            qtdProduto = this.state.vlMultiplicadorVenda;

            this.setState({ qtdProduto: formatToMilhar(qtdProduto) });

            return;
        }

        let valTotal = Number(
            Number(qtdProduto).toFixed(3) * Number(valUnitario).toFixed(2)
        )
            .toFixed(2)
            .split('.');

        valTotal[0] = 'R$ ' + valTotal[0].split(/(?=(?:...)*$)/).join('.');

        return valTotal.join(',');
    };

    replaceValueProd = (valUnitario) => {
        let valTotal = Number(valUnitario).toFixed(2).split('.');

        valTotal[0] = 'R$ ' + valTotal[0].split(/(?=(?:...)*$)/).join('.');

        return valTotal.join(',');
    };

    keyEnterPress = (key) => {
        if (key === 'Enter') {
            this.buscarPorCodigoBarras();
        }
    };

    handleFocus = (e) => {
        e.target.select();
    };

    onPressSincronizar = async () => {
        const { pedidoSelecionado } = this.props;
        const { idPedido } = pedidoSelecionado;
        this.setState({ isSincronizarLoading: true });

        const response = await sendPedidoFila({ idPedido });
        if (response.status === 200) {
            return this.setState({
                isSincronizarLoading: false,
                isSincronizarDisabled: true
            });
        }

        const { message = 'Não foi possível sincronizar.' } = response.data;

        this.props.addToast({
            text: message,
            more: 'OK',
            theme: message ? 'error' : 'success'
        });

        this.setState({ isSincronizarLoading: false });
    };

    modalAddProduto = () => {
        const { isSaving } = this.state;

        return (
            <Fragment>
                <Modal
                    width="600px"
                    title="Adicionar Produto ao Pedido"
                    isOpen={true}
                    onClose={() => this.closeModal(false)}
                    onSave={this.inserirProdutoPedido}
                    cancelText="Cancelar"
                    saveText="Adicionar"
                    isSaveButtonLoading={isSaving}
                    enabledClose={true}
                >
                    <div
                        style={{
                            flex: 10,
                            display: 'flex',
                            fontFamily: 'NunitoSans-Regular'
                        }}
                    >
                        <View
                            style={{
                                display: 'flex',
                                flex: 7,
                                marginRight: 8
                            }}
                        >
                            <View
                                style={{
                                    flex: 1,
                                    minHeight: 80,
                                    display: 'flex'
                                }}
                            >
                                <label style={{ fontSize: '1.6rem' }}>
                                    Código de Barras
                                </label>

                                <div
                                    style={{
                                        nt: 'center',
                                        flexDirection: 'row'
                                    }}
                                >
                                    <input
                                        maxLength={13}
                                        type="number"
                                        value={this.state.codigoBarras}
                                        autoFocus
                                        onChange={(e) =>
                                            this.changeCodigoBarras(e)
                                        }
                                        disabled={isSaving}
                                        style={{
                                            paddingLeft: 5,
                                            height: 35,
                                            width: '80%',
                                            fontSize: 16,
                                            borderTopLeftRadius: 5,
                                            borderBottomLeftRadius: 5,
                                            borderWidth: 1,
                                            borderColor: this.state.isSaving
                                                ? 'gray'
                                                : Colors.secondary
                                        }}
                                        onKeyPress={(e) =>
                                            this.keyEnterPress(
                                                e.nativeEvent.key
                                            )
                                        }
                                    />

                                    <input
                                        onClick={() =>
                                            this.buscarPorCodigoBarras()
                                        }
                                        value="Buscar"
                                        type="button"
                                        disabled={isSaving}
                                        style={{
                                            width: '20%',
                                            height: 39,
                                            fontSize: 16,
                                            textAlign: 'center',
                                            color: Colors.white,
                                            backgroundColor: this.state.isSaving
                                                ? 'gray'
                                                : Colors.secondary,
                                            borderWidth: 1,
                                            borderColor: Colors.secondary,
                                            borderTopRightRadius: 5,
                                            borderBottomRightRadius: 5,
                                            position: 'fixed',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </div>
                            </View>

                            {this.state.isSearching ? (
                                <ActivityIndicator color={Colors.secondary} />
                            ) : Object.keys(this.state.prodAdd).length ? (
                                <View>
                                    {this.renderizarProdutoSelecionado(
                                        this.state.prodAdd
                                    )}
                                </View>
                            ) : (
                                <View
                                    style={{
                                        flex: 1,
                                        minHeight: 80,
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginTop: 75
                                    }}
                                >
                                    {this.state.msgModal.length ? (
                                        <p style={{ fontSize: '1.8rem' }}>
                                            {this.state.msgModal}
                                        </p>
                                    ) : (
                                        <Fragment>
                                            <img
                                                alt="codigo barras"
                                                src={barCode}
                                                style={{
                                                    height: 45,
                                                    width: 55
                                                }}
                                            />

                                            <p style={{ fontSize: '1.8rem' }}>
                                                Digite o Código de Barras do
                                                Produto
                                            </p>
                                        </Fragment>
                                    )}
                                </View>
                            )}
                        </View>
                    </div>
                </Modal>
            </Fragment>
        );
    };

    modalStatusHistorico = () => {
        const { statusHistorico, dsTimeZone } = this.state;

        return (
            <Fragment>
                <Modal
                    size="comprovante"
                    title={`Histórico do pedido #${this.state.idPedido}`}
                    isOpen={true}
                    onClose={() => this.closeModalHistorico()}
                    enabledClose={true}
                    removeButtons={true}
                >
                    <HistoricoStatus
                        listStatus={statusHistorico}
                        dsTimeZone={dsTimeZone}
                    />
                </Modal>
            </Fragment>
        );
    };

    modalComprovante = () => {
        return (
            <Fragment>
                <Modal
                    size="image"
                    title={`Comprovante pedido #${this.state.idPedido}`}
                    isOpen={true}
                    onClose={() => this.closeModalComprovante()}
                    enabledClose={true}
                    removeButtons={true}
                >
                    {this.state.isLoadingComprovante ? (
                        <ActivityIndicator color={Colors.secondary} />
                    ) : (
                        <View style={{ alignItems: 'center' }}>
                            <View
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    overflow: 'hidden',
                                    alignItems: 'center'
                                }}
                            >
                                <img
                                    src={this.state.comprovantePedido}
                                    alt="Comprovante de retirada do pedido"
                                    style={{
                                        width: '100%'
                                    }}
                                />
                            </View>

                            <View>
                                <label
                                    style={{
                                        padding: '10px 10px',
                                        width: 180,
                                        backgroundColor: Colors.white,
                                        color: Colors.secondary,
                                        border: `solid 1px ${Colors.secondary}`,
                                        borderRadius: 6,
                                        textAlign: 'center',
                                        display: 'block',
                                        cursor: 'pointer',
                                        marginTop: 16
                                    }}
                                >
                                    <span
                                        style={{
                                            fontFamily: 'NunitoSans-Regular',
                                            fontSize: 14
                                        }}
                                    >
                                        Editar comprovante
                                    </span>

                                    <input
                                        type="file"
                                        style={{ display: 'none' }}
                                        onChange={this.onLoadImage}
                                        accept="image/x-png,image/jpeg,image/gif,image/jpg"
                                        disabled={
                                            this.state.isLoadingComprovante
                                        }
                                    />
                                </label>
                            </View>
                        </View>
                    )}
                </Modal>
            </Fragment>
        );
    };

    closeModalHistorico = () => {
        this.setState({ isOpenModalHistorico: false });
    };

    renderizarProdutoSelecionado = (produto) => {
        const lsProdutoImagem = produto.lsProdutoImagem || [];
        const [imgObj = {}] = lsProdutoImagem;
        const { ds_thumbnail_url: dsThumbnailUrl } = imgObj;

        return (
            <View
                style={{
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center'
                }}
            >
                <View>
                    <ProductImage
                        data={produto}
                        urlCdn={dsThumbnailUrl || urlCdn}
                        style={{
                            width: 202,
                            height: 143,
                            justifyContent: 'flex-start',
                            marginLeft: 50
                        }}
                        resizeMode={'center'}
                    />
                </View>

                <div style={{ width: '30%' }} />

                <View
                    style={{
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end'
                    }}
                >
                    <p style={{ margin: 0, color: 'gray', fontSize: '1.4rem' }}>
                        PRODUTO
                    </p>
                    <p
                        style={{ margin: 0, fontSize: '1.4rem' }}
                        data-tip={produto.dsProduto}
                    >
                        {produto.dsProduto.length > 37
                            ? `${produto.dsProduto.slice(0, 36)}...`
                            : produto.dsProduto}
                    </p>

                    {produto.dsProduto.length > 37 && (
                        <Tooltip
                         placement='top'
                        />
                    )}

                    <span style={{ height: 10 }} />

                    <p style={{ margin: 0, color: 'gray', fontSize: '1.4rem' }}>
                        {' '}
                        CÓDIGO DE BARRAS
                    </p>
                    <p style={{ margin: 0, fontSize: '1.4rem' }}>
                        {produto.nrEan}
                    </p>
                    <span style={{ height: 10 }} />
                    <p style={{ margin: 0, color: 'gray', fontSize: '1.4rem' }}>
                        PREÇO UNITÁRIO
                    </p>
                    <p style={{ margin: 0, color: 'blue', fontSize: '1.4rem' }}>
                        {this.replaceValueProd(produto.vlPreco)}
                    </p>
                    <span style={{ height: 10 }} />
                    <p style={{ margin: 0, color: 'gray', fontSize: '1.4rem' }}>
                        QUANTIDADE
                    </p>
                    <div style={{ flexDirection: 'row' }}>
                        <MaskedInput
                            mask={unidadeMask}
                            id="qtProduto"
                            name="qtProduto"
                            value={this.state.qtdProduto}
                            maxLength={10}
                            onChange={this.handleQuantidadeChange}
                            onBlur={this.handleQuantidadeBlur}
                            render={(ref, props) => (
                                <StyledInput ref={ref} {...props} />
                            )}
                            onFocus={(e) => this.handleFocus(e)}
                            type="tel"
                        />

                        <span
                            style={{
                                color: '#000',
                                fontSize: '1.4rem',
                                marginTop: 0,
                                marginBottom: 0
                            }}
                        >
                            {'  '}
                            {this.state.prodAdd.fgPesavel ? 'KG' : 'UN'}
                        </span>
                    </div>
                    <span style={{ height: 10 }} />
                    <p style={{ margin: 0, color: 'gray', fontSize: '1.4rem' }}>
                        VALOR TOTAL
                    </p>
                    <p
                        style={{
                            margin: 0,
                            color: 'blue',
                            fontWeight: 'bold',
                            fontSize: '1.4rem'
                        }}
                    >
                        {' '}
                        {this.calcValTotalProd(produto.vlPreco)}
                    </p>
                </View>
            </View>
        );
    };
}

const mapStateToProps = ({ pedidoSelecionado, pedidos, user }) => ({
    pedidoSelecionado,
    pedidos,
    user
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { ...toastActions, ...pedidosActions, ...pedidoSelecionadoActions },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PedidoDetalhe);
